var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VxWalkthruStep',{attrs:{"step":_vm.step},scopedSlots:_vm._u([{key:"detail",fn:function(){return [_c('CurrentReleaseStepDetail',{attrs:{"release":_vm.release}})]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.$t("settings.softwareUpdate.currentReleaseStep.title"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }